import styled, { keyframes } from 'styled-components';

import { mediaQuery } from '../../../../../styles/global';
import { Assets } from '../../../../../utils/assets';

const BackgroundKeyframe = keyframes`
  0% { 
    opacity: 0;
   }
  100% {
    opacity: 1;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
  margin-bottom: 120px;
  margin-top: 220px;
  overflow: visible;
  border-radius: 16px;
  justify-content: space-between;
  background: url(${Assets.images.downloadBlurBg.url});
  background-repeat: no-repeat;
  background-size: cover;
  padding-bottom: 3rem;
  transition: background 0.3s;

  ${mediaQuery.maxWidth.tablet} {
    flex-direction: column;
    background: url(${Assets.images.downloadBlurMobileBg.url});
    background-size: cover;
    background-repeat: no-repeat;
    margin: 0 16px;
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 64px;
  margin-right: 20px;
  margin-top: 77px;
  max-width: 486px;
  z-index: 1;
  font-family: ${({ theme }) => theme.fontFamily.regular};
  background: transparent;
  transition: background 0.3s;
  width: 50%;

  ${mediaQuery.maxWidth.tablet} {
    width: unset;
    margin: 24px 40px;
  }
`;

export const BackgroundBlur = styled.div`
  pointer-events: none;
  position: absolute;
  display: flex;
  width: 100%;
  height: 100%;
  right: -100px;
  top: 0;
  animation: ${BackgroundKeyframe};
  animation-duration: 2500ms;
  animation-fill-mode: forwards;
  transform: translate3d(0, 0, 0);
  justify-content: flex-end;
  align-items: flex-end;
  transition: right 0.3s;
  transform: scale(2.3);
`;

export const LeftTitleContainer = styled.div`
  color: white;
  margin: 0;
  padding: 0;
  margin-top: 16px;
  font-family: ${({ theme }) => theme.fontFamily.bold};
  font-size: 3rem;
  width: 100%;

  & > p {
    margin: 0;
    padding: 0;
    font-size: clamp(3.5rem, 8vw - 2rem, 4rem);
  }
`;

export const LeftDescriptionContainer = styled.div`
  margin-top: 32px;
  font-size: 18px;
  opacity: 0.75;
  font-family: ${({ theme }) => theme.fontFamily.regular};

  ${mediaQuery.maxWidth.tablet} {
    margin-bottom: 40px;
  }
`;

export const LeftButtonContainer = styled.div`
  margin-top: 48px;
  display: flex;
  flex-direction: column;
  gap: 24px;

  ${mediaQuery.maxWidth.tablet} {
    display: none;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

export const ButtonNote = styled.p`
  margin-left: 24px;
  font-size: 14px;
  color: white;
  opacity: 0.75;
  font-family: ${({ theme }) => theme.fontFamily.regular};
`;

export const Button = styled.a`
  border: none;
  background-color: white;
  color: black;
  font-family: ${({ theme }) => theme.fontFamily.bold};
  font-size: 14px;
  border-radius: 52px;
  padding: 0 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: box-shadow 0.3s;
  text-decoration: none;
  min-height: 52px;

  &:hover {
    box-shadow: 0px 0px 10px 0px rgba(255, 255, 255, 1);
  }
`;

export const ButtonIcon = styled.img`
  width: 20px;
  height: 20px;
  margin-right: 14px;
  position: relative;
  top: -2px;
`;

export const LeftQuestionContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 48px;

  & > a {
    color: white;
    text-decoration: underline;
    margin-left: 4px;
  }
`;

export const Image = styled.img`
  width: 50%; 
  height: 100%;
  object-fit: contain;
  z-index: 1;

  ${mediaQuery.maxWidth.tablet} {
    width: 100%;
  }
`
